import { InsightType } from '../../domain/insightType';
import { arraysAreEqual } from '../../services/array';
import { useInsightsQuery } from '../insights/useInsightsQuery';

import { useCompetitorsQuery } from './useCompetitorsQuery';

export const useCheckIfStaleOpportunity = () => {
  const competitorsQuery = useCompetitorsQuery();
  const insights = useInsightsQuery()?.data ?? [];

  return (insightId: string) => {
    const insight = insights.find((i) => i.id === insightId);

    if (!insight || insight.insightType !== InsightType.Opportunity || !competitorsQuery.data) {
      return false;
    }

    const selectedCompetitorDomains = competitorsQuery.data
      .filter((c) => c.isSelected)
      .map((c) => c.domain)
      .sort();

    const competitors = insight.competitors?.map((c) => c.domain).sort() ?? [];

    return !arraysAreEqual(selectedCompetitorDomains, competitors);
  };
};
